<template>
  <div class="w-full min-h-screen grid grid-rows-[min-content_1fr]">
    <header
      class="w-full bg-white py-6 px-8 sm:px-32 z-20 flex items-center justify-between sticky top-0 shadow-header"
    >
      <img class="md:h-[32px] h-6" src="/images/logo/logoLong.svg" alt="USAT" />
      <CommonLanguageSwitcher class="!my-0" />
    </header>

    <div class="h-full w-full bg-gray-100 px-5 sm:px-32 py-8">
      <div
        class="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-[302px_1fr] gap-5"
      >
        <PublicMenu class="md:sticky md:top-[130px]" />
        <div class="w-full min-w-0">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { onBeforeUnmount, onMounted } from "vue";
import { CommonLanguageSwitcher } from "@/components/Common";
import PublicMenu from "@/modules/PublicProfile/components/PublicMenu.vue";

/**
 * The layout for the page a contract's QR code opens. Nobody is signed in here, so there is no
 * profile header (it would fetch the signed-in student) and no logout, only the logo and language.
 */
let robots: HTMLMetaElement | null = null;

// A person's data behind a bearer link has no business in a search index.
onMounted(() => {
  robots = document.createElement("meta");
  robots.name = "robots";
  robots.content = "noindex, nofollow";
  document.head.appendChild(robots);
});

onBeforeUnmount(() => robots?.remove());
</script>
